import { IRegionFAQ } from 'api/region/types';
import React, { useContext, useEffect } from 'react';

export interface IRegionBubblingProps {
  faq?: IRegionFAQ;
  button?: {
    title: string,
    onClick: () => void,
  }
}

export type IBubbleContext<T> = ((props: T) => void) | undefined;
export const RegionLayoutContext = React.createContext<IBubbleContext<IRegionBubblingProps>>(undefined);
export const useRegionLayoutBubble = (props: IRegionBubblingProps) => {
  const setProps = useContext(RegionLayoutContext);
  useEffect(() => {
    if (setProps) {
      setProps(props);
    }
  }, [props.button, props.faq, setProps]);
};
